import React, { useContext } from 'react';
import { LoadingSpinner } from '../loading-spinner/index.js';
import { LoadingSpinnerContainer } from './select.styles.js';
import { SelectContext } from './use-select-state.js';
export const SelectLoadingComponent = () => {
    const { props } = useContext(SelectContext).selectState;
    return props.loading === 'spinner' ? (React.createElement(LoadingSpinnerContainer, null,
        React.createElement(LoadingSpinner, null))) : null;
};
//# sourceMappingURL=select-loading.component.js.map